import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "./Education.scss";
export default function Education() {
  return (
    <div className="education" id="education">
      <h2>Education</h2>
      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "#2A3956", color: "#dccaca" }}
          contentArrowStyle={{ borderRight: "7px solid  #2A3956" }}
          date="2019 - present"
          iconStyle={{
            background: "linear-gradient(270deg, #13ADC7 0%, #945DD6) 100%",
            color: "#0f0e0e",
          }}
        >
          <h1 className="vertical-timeline-element-title mb-2">
            Chittagong University of Engineering and Technology
          </h1>
          <h3 className="vertical-timeline-element-subtitle">BSC(Engr.)</h3>
          <p>Current i am studying here.</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "#2A3956", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  #2A3956" }}
          date="2019"
          iconStyle={{
            background: "linear-gradient(270deg, #13ADC7 0%, #945DD6) 100%",
            color: "#fff",
          }}
        >
          <h1 className="vertical-timeline-element-title mb-2">
            Chittagong College
          </h1>
          <h3 className="vertical-timeline-element-subtitle">
            Higher Secondary
          </h3>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "#2A3956", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  #2A3956" }}
          date="2017"
          iconStyle={{
            background: "linear-gradient(270deg, #13ADC7 0%, #945DD6) 100%",
            color: "#fff",
          }}
        >
          <h1 className="vertical-timeline-element-title mb-2">
            Chittagong Collegiate School
          </h1>
          <h3 className="vertical-timeline-element-subtitle">Secondary</h3>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
}
